import React from "react";
import ProcurarTurma from "../../../../features/Turmas/_Aux/ProcurarTurma";

const CaixaPesquisa = ({ pesquisa, placeholder, tem_placeholder, onChange }) => {
    const HandleKeyPress = e => {
        if (e.key === "Enter") {
            var pesquisa = e.target.value;
            onChange(pesquisa);
        }
    };

    const reset = () => {
        onChange("");
    };

    return (
        <ProcurarTurma
            style={{ width: "100%" }}
            pesquisa={pesquisa}
            tem_placeholder={tem_placeholder}
            placeholder={placeholder}
            HandleKeyPress={HandleKeyPress}
            resetCaixaProcura={reset}
        />
    );
};

export default CaixaPesquisa;
